import dayjs from 'dayjs';
import { API_BASE_URL } from '../constants/api';
import { getPriceForCurrency } from './invoiceHelpers';

export const ACCOUNT_BASE_IDS = {
  SALE_CLIENT: 12,
  PURCHASE_SUPPLIER: 21,
};

export const getAccountBaseId = (isPurchase) => (
  isPurchase ? ACCOUNT_BASE_IDS.PURCHASE_SUPPLIER : ACCOUNT_BASE_IDS.SALE_CLIENT
);

export const transformInvoiceItems = (items, materialPrices = []) => {
  if (!Array.isArray(items)) return [];

  return items.map(item => {
    const transformed = {
      Id: item.id,
      MaterialId: item.materialId,
      Amount: item.amount,
      UnitPrice: item.unitPrice,
      Discount: item.discount,
      Notes: item.notes,
      Currency: item.currency,
      RetailPrice: item.retailPrice,
      WholesalePrice: item.wholesalePrice,
    };

    if (item.materialId && item.currency && materialPrices.length > 0) {
      const priceInfo = materialPrices.find(p => p.materialId === item.materialId);
      const pricesObj = priceInfo?.prices || {};
      const priceForCurrency = getPriceForCurrency(pricesObj, item.currency);

      if (priceForCurrency) {
        transformed.UnitPrice = transformed.UnitPrice ?? priceForCurrency.unitPrice;
        transformed.RetailPrice = transformed.RetailPrice ?? priceForCurrency.retailPrice;
        transformed.WholesalePrice = transformed.WholesalePrice ?? priceForCurrency.wholesalePrice;
      }
    }

    return transformed;
  });
};

export const transformInvoiceVouchers = (vouchers) => {
  if (!Array.isArray(vouchers)) return [];

  return vouchers.map(voucher => ({
    Id: voucher.id,
    Value: voucher.value,
    Date: voucher.date ? dayjs(voucher.date) : null,
    Currency: voucher.currency,
    Notes: voucher.notes,
    Factor: voucher.factor,
  }));
};

export const getInvoiceFormValues = (editingInvoice, materialPrices = []) => ({
  ...editingInvoice,
  ClientAccountId: editingInvoice.clientAccountId,
  CashAccountId: editingInvoice.cashAccountId,
  RepositoryId: editingInvoice.repositoryId,
  Items: transformInvoiceItems(editingInvoice.items, materialPrices),
  Vouchers: transformInvoiceVouchers(editingInvoice.vouchers || []),
  Discount: editingInvoice.discount || 0,
});

export const filterInvoiceItems = (items = []) => (
  items.filter(item => item && item.MaterialId)
);

export const normalizeInvoiceItemForPayload = (item) => ({
  ...item,
  Id: item.Id ?? item.id ?? 0,
  Discount: item.Discount ?? item.discount ?? 0,
  Notes: item.Notes ?? item.notes ?? '',
});

export const normalizeInvoiceItemsForPayload = (items = []) => (
  items.map(normalizeInvoiceItemForPayload)
);

export const buildInvoicePayload = ({ validatedValues, filteredItems, vouchers }) => ({
  ...validatedValues,
  Items: normalizeInvoiceItemsForPayload(filteredItems),
  Vouchers: vouchers || [],
  cashAccountId: 111,
});

export const getInvoiceEndpoint = ({ mode, editingInvoice }) => {
  if (editingInvoice) {
    return `${API_BASE_URL}Invoice/Update/${editingInvoice.id}`;
  }

  return mode === 'sale'
    ? `${API_BASE_URL}Invoice/CreateSale`
    : `${API_BASE_URL}Invoice/CreatePurchase`;
};

export const getInvoiceSuccessMessage = ({ mode, editingInvoice }) => (
  editingInvoice
    ? 'تم تحديث الفاتورة بنجاح'
    : `تم إنشاء فاتورة ${mode === 'sale' ? 'البيع' : 'الشراء'} بنجاح`
);

export const restoreEditedSaleStockAmounts = (saleMaterials, editingInvoice) => {
  if (!editingInvoice || !Array.isArray(saleMaterials)) return saleMaterials;

  const invoiceItems = Array.isArray(editingInvoice.items) ? editingInvoice.items : [];

  return saleMaterials.map(saleMaterial => {
    const invoiceItem = invoiceItems.find(item => item.materialId === saleMaterial.id);
    if (!invoiceItem) return saleMaterial;

    return {
      ...saleMaterial,
      stockAmount: (saleMaterial.stockAmount || 0) + (invoiceItem.amount || 0),
    };
  });
};
